export const GET_CONFIG = '/api/config'
export const SET_CONFIG = '/api/config'
export const GET_ROUTE = '/api/route'
export const SET_ROUTE = '/api/route'